export default[
    {
        path: '/calidad',
        name: 'calidad',
        component: () => import(/* webpackChunkName: "calidad" */ '@/views/Calidad.vue'),
        roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
        meta: {
            requiresAuth: true,
            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
        },
        children:[
            {
                path:'reuniones',
                component: () => import(/* webpackChunkName: "reuniones" */ '@/views/calidad/reuniones/CalidadReuniones.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                },
                children:[
                    {
                        path:'/',
                        name:'calidadReuniones',
                        component: () => import(/* webpackChunkName: "calidadReuniones" */ '@/views/calidad/reuniones/CalidadCalendarioComites.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'reunion/:id',
                        name:'detalleReunion',
                        component: () => import(/* webpackChunkName: "detalleReunion" */ '@/views/calidad/reuniones/DetalleReunion.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'comites',
                        name:'calidadComites',
                        component: () => import(/* webpackChunkName: "calidadComites" */ '@/views/calidad/reuniones/CalidadComites.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'acuerdos',
                        name:'calidadAcuerdos',
                        component: () => import(/* webpackChunkName: "calidadAcuerdos" */ '@/views/calidad/reuniones/Acuerdos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                ],
            },

            {
                path:'mecic',
                component: () => import(/* webpackChunkName: "mecic" */ '@/views/calidad/mecic/Mecic.vue'),
                roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                children:[
                    {
                        path:'/',
                        name:'mecicPrincipal',
                        component: () => import(/* webpackChunkName: "mecicPrincipal" */ '@/views/calidad/mecic/MecicPrincipal.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'evaluacion/:id',
                        name:'mecicEvaluacion',
                        component: () => import(/* webpackChunkName: "mecicEvaluacion" */ '@/views/calidad/mecic/MecicEvaluacion.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                ],
            },

            {
                path:'evaluaciones',
                component: () => import(/* webpackChunkName: "evaluaciones" */ '@/views/calidad/evaluaciones/CalidadEvaluaciones.vue'),
                meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                children:[
                    {
                        path:'/',
                        name:'calidadEvaluaciones',
                        component: () => import(/* webpackChunkName: "calidadEvaluaciones" */ '@/views/calidad/evaluaciones/CalidadListEvaluaciones.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'insumoslavado',
                        name:'calidadInsumosLavado',
                        component: () => import(/* webpackChunkName: "calidadInsumosLavado" */ '@/views/calidad/evaluaciones/aesp5/insumosManos/CalidadMaterialAseoManos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'lavadomanos',
                        name:'lavadoManos',
                        component: () => import(/* webpackChunkName: "lavadoManos" */ '@/views/calidad/evaluaciones/aesp5/lavadoManos/lavadoManos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'cincomomentos',
                        name:'calidad5momentos',
                        component: () => import(/* webpackChunkName: "calidad5momentos" */ '@/views/calidad/evaluaciones/aesp5/cincoMomentos/Calidad5momentos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'datosid',
                        name:'calidadDatosId',
                        component: () => import(/* webpackChunkName: "calidadDatosId" */ '@/views/calidad/evaluaciones/aesp1/datosId/datosId.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'datoshospital',
                        name:'calidadDatosHospital',
                        component: () => import(/* webpackChunkName: "calidadDatosHospital" */ '@/views/calidad/evaluaciones/aesp1/hospitalId/datosHospitalId.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'satisfaccionUsuarios',
                        name:'calidadSatisfaccionUsuarios',
                        component: () => import(/* webpackChunkName: "calidadSatisfaccionUsuarios" */ '@/views/calidad/evaluaciones/gld/CalidadSatisfaccion.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'carroRojo',
                        name:'EvaluacionCarroRojo',
                        component: () => import(/* webpackChunkName: "EvaluacionCarroRojo" */ '@/views/calidad/evaluaciones/aesp3/carroRojo/carroRojo.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'idMedicamentos',
                        name:'identificacionMedicamentos',
                        component: () => import(/* webpackChunkName: "identificacionMedicamentos" */ '@/views/calidad/evaluaciones/aesp3/idMedicamentos/idMedicamentos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'prevcaidas',
                        name:'prevcaidas',
                        component: () => import(/* webpackChunkName: "prevcaidas" */ '@/views/calidad/evaluaciones/aesp6/PrevencionCaidas.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                ],
            },
            {
                path:'riesgos',
                component: () => import(/* webpackChunkName: "riesgos" */ '@/views/calidad/riesgos/matrizr.vue'),
                roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                children:[
                    {
                        path:'/',
                        name:'matrizrList',
                        component: () => import(/* webpackChunkName: "matrizrList" */ '@/views/calidad/riesgos/MatrizrList.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:':id',
                        name:'matrizrEditar',
                        component: () => import(/* webpackChunkName: "matrizrEditar" */ '@/views/calidad/riesgos/NuevoRiesgo.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                    {
                        path:'nuevoriesgo',
                        name:'matrizrNuevo',
                        component: () => import(/* webpackChunkName: "matrizrNuevo" */ '@/views/calidad/riesgos/NuevoRiesgo.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                        },
                    },
                ]
            },
            {
                path:'irsp',
                component: () => import(/* webpackChunkName: "irsp" */ '@/views/calidad/irsp/IrspMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                },
            },
            {
                path:'iaas',
                component: () => import(/* webpackChunkName: "iaas" */ '@/views/calidad/iaas/IaasMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                },
            },
            {
                path:'sismos',
                component: () => import(/* webpackChunkName: "sismos" */ '@/views/calidad/sismos/SismosMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN', 'ROLE_CALIDAD', 'ROLE_CALIDAD_ADMIN'],
                },
            },
        ],
    }
]